import clsApi from '@cls/clsApi'

class clsReport extends clsApi {

    async run(idReport, paging, columns, filter, variations) {
        return await this.post(`run`, {id: idReport, paging, columns, filter, variations});
    }
}

export default clsReport;
